import { FC, ReactNode } from 'react';

import { ActionBar, BottomSheet, Button, Text, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    close: 'common.close',
};

interface MobileTooltipBottomSheetProps {
    title: ReactNode;
    children: ReactNode;
    visible: boolean;
    onClose: () => void;
    dataQa: string;
}

export const MobileTooltipBottomSheet: FC<MobileTooltipBottomSheetProps> = ({
    title,
    children,
    visible,
    onClose,
    dataQa,
}) => {
    const trls = useTrls();

    return (
        <BottomSheet
            visible={visible}
            onClose={onClose}
            height="content"
            showDivider="always"
            data-qa={dataQa}
            footer={
                <ActionBar
                    primaryActions={
                        <Button
                            stretched
                            size="medium"
                            mode="secondary"
                            style="neutral"
                            onClick={onClose}
                            data-qa={`${dataQa}-close`}
                        >
                            {trls(TrlKeys.close)}
                        </Button>
                    }
                />
            }
        >
            <VSpacingContainer default={8}>
                <Text typography="title-4-semibold">{title}</Text>
                <Text typography="paragraph-1-regular">{children}</Text>
            </VSpacingContainer>
            <VSpacing default={24} />
        </BottomSheet>
    );
};
